module.exports = __webpack_public_path__ + "static/img/info_stage1.ec1b1e2.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/info_stage1.png
// module id = K4pB
// module chunks = 1